import { LitElement, html } from 'lit';

/**
 * Quote Header Component
 * Displays company name, campaign name, and start date in a responsive layout
 * Uses DaisyUI card components with Tailwind for styling
 */
class QuoteHeader extends LitElement {
    static properties = {
        quoteData: { type: Object },
    };

    // Use Light DOM for Tailwind compatibility
    createRenderRoot() {
        return this;
    }

    constructor() {
        super();
        this.quoteData = null;
    }

    get companyName() {
        return this.quoteData?.custName || 'N/A';
    }

    get campaignName() {
        return this.quoteData?.jobname || 'N/A';
    }

    get startDate() {
        return this.quoteData?.startDate || 'N/A';
    }

    render() {
        if (!this.quoteData) {
            return html` <div class="skeleton h-32 w-full"></div> `;
        }

        return html`
            <!-- Stacked cards (< md) -->
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 md:hidden">
                <div class="card-standard sm:col-span-2">
                    <div class="card-body p-4">
                        <h3 class="field-label">Company Name</h3>
                        <p class="text-lg font-medium text-gray-900">${this.companyName}</p>
                    </div>
                </div>
                <div class="card-standard">
                    <div class="card-body p-4">
                        <h3 class="field-label">Campaign Name</h3>
                        <p class="text-lg font-medium text-gray-900">${this.campaignName}</p>
                    </div>
                </div>
                <div class="card-standard">
                    <div class="card-body p-4">
                        <h3 class="field-label">Campaign Start Date</h3>
                        <p class="text-lg font-medium text-gray-900">${this.startDate}</p>
                    </div>
                </div>
            </div>

            <!-- Divided row (md+) -->
            <div class="hidden md:block">
                <div class="card-standard">
                    <div class="card-body p-0">
                        <div class="grid grid-cols-3 divide-x divide-base-300">
                            <div class="p-4">
                                <h3 class="field-label mb-2">Company Name</h3>
                                <p class="text-lg font-medium text-gray-900">${this.companyName}</p>
                            </div>
                            <div class="p-4">
                                <h3 class="field-label mb-2">Campaign Name</h3>
                                <p class="text-lg font-medium text-gray-900">
                                    ${this.campaignName}
                                </p>
                            </div>
                            <div class="p-4">
                                <h3 class="field-label mb-2">Campaign Start Date</h3>
                                <p class="text-lg font-medium text-gray-900">${this.startDate}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
}

customElements.define('quote-header', QuoteHeader);
